import { Box, Grid, useTheme } from "@material-ui/core"
import { Typography } from "@mui/material"
import React from "react"
import FoodIcon from "assets/icons/food.svg"
import CocktailIcon from "assets/icons/cocktail.svg"
import WineIcon from "assets/icons/wine.svg"
import VIPIcon from "assets/icons/vip.svg"
import historyBackgound from "assets/images/historyBackground.svg"
import "../MobilePreview.scss"

const History = ({ data }) => {
  const theme = useTheme()

  return (
    <div>
      <Box
        className="mobile-preview__history"
        sx={{
          backgroundImage: `url(${data?.item_history?.image || historyBackgound})`
        }}>
        <Grid item container justifyContent="center" mb={2}>
          <img
            src={
              data?.bar_category
                ? CocktailIcon
                : data?.country || data?.wine_category
                ? WineIcon
                : data?.meal_period?.name === "VIP"
                ? VIPIcon
                : FoodIcon
            }
            className="mobile-preview__section-icon"
          />
        </Grid>
        <Typography variant="h2" align="center" className="mobile-preview__section-title">
          {data?.item_history?.title}
        </Typography>
        <Typography
          variant="body2"
          className="mobile-preview__history-text"
          color={theme.palette.text.secondary}>
          {data?.item_history?.description}
        </Typography>
      </Box>
    </div>
  )
}

export default History
